import { useTranslation } from 'react-i18next'

import { CardBasicIcon } from '@arcade/web/icons/react'
import { InstrumentType } from '@cash-web/protos/squareup/common/instrument.pb'

import AmexIcon from '../../assets/instrument-amex.svg?url'
import DiscoverIcon from '../../assets/instrument-discover.svg?url'
import MastercardIcon from '../../assets/instrument-mastercard.svg?url'
import VisaIcon from '../../assets/instrument-visa.svg?url'

export { AmexIcon as AmexLogo, DiscoverIcon as DiscoverLogo, MastercardIcon as MastercardLogo, VisaIcon as VisaLogo }

const INSTRUMENT_ICONS: Partial<Record<InstrumentType, string>> = {
  MASTER_CARD: MastercardIcon,
  AMERICAN_EXPRESS: AmexIcon,
  DISCOVER: DiscoverIcon,
  VISA: VisaIcon,
}

type CardImageProps = { brand: InstrumentType }
export const CardImage = ({ brand }: CardImageProps) => {
  const { t } = useTranslation()

  return INSTRUMENT_ICONS[brand] ? (
    <img
      width="100%"
      src={INSTRUMENT_ICONS[brand]}
      alt={t('{brand} logo', { brand, context: 'alt text for logo of bank' })}
    />
  ) : (
    <CardBasicIcon aria-label={t('debit card image', { context: 'aria-label for debit card image' })} />
  )
}
